{
  "total": "總資產估值",
  "available": "可用餘額",
  "frozen": "鎖定資產",
  "bonus-balance": "獎勵餘額",
  "bonus-balance-label": "獎勵餘額：{{amount}}",
  "action": {
    "deposit": "收幣",
    "convert": "閃兌",
    "buySellOrder": "買賣幣",
    "customerService": "客服"
  },
  "assets": "資產",
  "coin": {
    "YBB": "寶幣",
    "usdt": "USDT"
  }
}
